import { useNavigate } from "react-router-dom";
import { Header } from "@/components/Header";
import { Card } from "@/components/ui/card";

const ViewAnalytics = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      <Header
        onNewProject={() => navigate("/new-project")}
        onViewProjects={() => navigate("/projects")}
      />

      <main className="container mx-auto px-4 py-6">
        <div className="space-y-6">
          <h1 className="text-3xl font-bold">Analytics Dashboard</h1>
          <Card className="p-6">
            <div className="text-center py-8">
              <h2 className="text-xl font-semibold mb-2">Project Analytics</h2>
              <p className="text-muted-foreground mb-4">
                View detailed analytics for your renovation projects
              </p>
              <div className="text-sm text-muted-foreground">
                <p>• Project completion rates and timelines</p>
                <p>• Revenue analytics and profit margins</p>
                <p>• Customer satisfaction metrics</p>
                <p>• Service performance comparisons</p>
              </div>
            </div>
          </Card>
        </div>
      </main>
    </div>
  );
};

export default ViewAnalytics;
